<script lang="ts" setup>
import type { SwiperOptions } from 'swiper'

import SkeletonSpecialityCarouselItem from '~/components/skeleton/SkeletonSpecialityCarouselItem.vue'
import { useSpecialitiesStore } from '~/store/specialities'

defineProps<{
  activeId: string|null
}>()

const emit = defineEmits<{
  (e: 'setActiveId', x: string): void
}>()

const galleryOptions: SwiperOptions = {
  breakpoints: {
    1280: { slidesPerGroup: 1, slidesPerView: 7 },
    1024: { slidesPerGroup: 1, slidesPerView: 5 },
    768: { slidesPerGroup: 1, slidesPerView: 4.5 },
    640: { slidesPerGroup: 1, slidesPerView: 3.5 },
    360: { slidesPerGroup: 1, slidesPerView: 2.5 },
    270: { slidesPerGroup: 1, slidesPerView: 1.5 }
  },
  lazy: true,
  observer: true,
  preventClicksPropagation: true,
  preventInteractionOnTransition: true,
  spaceBetween: 8
}

const specialitiesStore = useSpecialitiesStore()
const { getSpecialities } = storeToRefs(specialitiesStore)

specialitiesStore.fetchSpecialities()
</script>

<template>
  <div class="wrapper">
    <Gallery class="!max-w-full p-0" :options="galleryOptions">
      <template v-if="specialitiesStore.isDataLoading">
        <SkeletonSpecialityCarouselItem v-for="x in 9" :key="x" />
      </template>
      <template v-else-if="getSpecialities.length">
        <a
          v-for="x in getSpecialities"
          :key="x.id"
          class="
            swiper-slide max-6-slides
            box-border flex h-auto flex-col items-start justify-between
            rounded-3xl border border-solid border-transparent bg-white p-3
            !no-underline
            md:items-center md:p-5
          "
          :class="x.id === activeId ? 'text-main-green font-medium !border-main-green' : 'text-main-dark'"
          href="#"
          @click.prevent="emit('setActiveId', x.id)"
        >
          <img alt="speciality icon" class="h-[42px] md:h-auto" :src="x.attributes.iconUrl">
          <p class="mt-3 text-sm md:text-center md:text-base">{{ x.attributes.name }}</p>
        </a>
      </template>
    </Gallery>
  </div>
</template>

<style lang="scss" scoped>
@use 'assets/css/gallery';

.gallery {
  padding: 0;
}

@media screen and (max-width: 767px) {
  :deep(.swiper-container) {
    padding: 0 !important;
  }
}

:deep(.swiper-button-prev), :deep(.swiper-button-next) {
  background-color: #F8F8F8;
  border-color: #eee;
  color: black;

  @media (max-width: 768px) {
    display: none;
  }
}

:deep(.swiper-button-prev) {
  left: -1rem !important;
}

:deep(.swiper-button-next) {
  right: -1rem !important;
}
</style>
